import { Component, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReminderDto } from '@authority-labs/api-interfaces';
import { AuthenticationService } from '@check-list/app/auth/authentication.service';
import { UsersService } from '@check-list/modules/users/users.service';
import { CommonService } from '@check-list/shared/services/common/common.service';
import { ReminderService } from '@check-list/shared/services/reminder/reminder.service';
import { differenceInCalendarDays } from 'date-fns';

@Component({
  templateUrl: './create-reminder-dialog.component.html',
  styleUrls: ['./create-reminder-dialog.component.scss']
})
export class CreateReminderDialogComponent {
  translPath = 'notice.newReminderForm.';
  reminder: ReminderDto;
  editableReminder: ReminderDto;
  isNewReminder = true;
  entity: string;
  entityId: number;

  today = new Date();

  constructor(
    private reminderService: ReminderService,
    public dialogRef: MatDialogRef<CreateReminderDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: { reminder: ReminderDto; entity: string; entityId: number },
    private authService: AuthenticationService,
    public usersService: UsersService,
    private commonService: CommonService
  ) {
    this.editableReminder = data.reminder;
    this.entity = data.entity;
    this.entityId = data.entityId;
    this.isNewReminder = !this.editableReminder;
    this.reminder = this.isNewReminder
      ? ReminderDto.instanceOf({
          recipientName: authService.getUsername(),
          entity: this.entity,
          entityId: this.entityId
        })
      : {
          ...this.editableReminder
        };
  }

  disabledDate = (current: Date): boolean =>
    // Can not select days before today
    differenceInCalendarDays(this.today, current) > 0;

  get title(): string {
    return `${this.translPath}${this.isNewReminder ? 'titleAdd' : 'titleEdit'}`;
  }

  get selectedOwner(): boolean {
    return this.reminder.recipientName === this.authService.getUsername();
  }

  saveReminder() {
    this.reminderService.createOne(this.reminder).subscribe(
      (res) => {
        this.dialogRef.close(res);
      },
      (error) => console.error(error)
    );
  }

  onNoteChange(note: string) {
    this.reminder.note = note;
  }

  disabledSaveButton(form: NgForm) {
    if (this.isNewReminder) {
      return form.control.invalid;
    } else {
      const noChanges =
        this.reminder.name === this.editableReminder.name &&
        this.reminder.date === this.editableReminder.date &&
        this.reminder.note === this.editableReminder.note &&
        this.reminder.recipientName === this.editableReminder.recipientName &&
        this.reminder.isPrivate === this.editableReminder.isPrivate;
      return form.control.invalid || noChanges;
    }
  }

  selectedRecipient() {
    if (!this.selectedOwner) {
      this.reminder.isPrivate = false;
    }
  }

  getLink(entity: string, entityId: number): string[] {
    return this.commonService.getLinkToEntity(entity, entityId);
  }
}
